import { getAuthHeaders, tempMeeApi } from '~/services/api';
import { IGetOfficePlanDetailApiResponse } from '../types';

export const getOfficePlanDetail = async (
  planId: string,
): Promise<IGetOfficePlanDetailApiResponse> => {
  const headers = await getAuthHeaders();

  const response = await tempMeeApi.get<IGetOfficePlanDetailApiResponse>(
    `/payment/user/office-plan/${planId}`,
    {
      headers,
    },
  );

  return response.data;
};
